import * as types from './mutation-types';

export default {
  [types.SET_CST_COLLECTION](state, payload) {
    state.cstCollection = payload;
  },
  [types.SET_CST_IPI_COLLECTION](state, payload) {
    state.cstIPICollection = payload;
  },
  [types.SET_CST_PIS_COLLECTION](state, payload) {
    state.cstPISCollection = payload;
  },
  [types.SET_CST_COFINS_COLLECTION](state, payload) {
    state.cstCOFINSCollection = payload;
  },
};
